import productsAPI from "@/api/products";
import moment from 'moment';

const state = () => ({
  productListConfig: {
    paginationCount: 0,
    paginationLimit: 50,
    paginationPage: 1,
    multiSort: [],
    kind: [],
    status: [],
    statusReason: [],
    upgradeStatus: [],
    version: [],
    supplier: "",
    tariff: [],
    outOfContract: "",
    outOfPromo: "",
    hardware: "",
    headset: "",
    ownPhoneSetup: "",
    ipex: "",
    callRecording: "",
    international: "",
    audio: "",
    nonGeo: "",
    crmConnect: "",
    phoneDelivery: "",
    numberPort: ""
  },
  productList: [],
  productListLoading: false,
  productListError: null,
});

const mutations = {
  UPDATE_PRODUCTS_LIST_FILTERS(state, payload) {
    state.productListConfig.paginationLimit = (payload.itemsPerPage!==undefined)?payload.itemsPerPage:state.productListConfig.paginationLimit;
    state.productListConfig.paginationPage = (payload.page)?payload.page:state.productListConfig.paginationPage;
    state.productListConfig.multiSort = (payload.multiSort!==undefined)?payload.multiSort:state.productListConfig.multiSort;
    state.productListConfig.kind = (payload.kind!==undefined)?payload.kind:state.productListConfig.kind;
    state.productListConfig.status = (payload.status!==undefined)?payload.status:state.productListConfig.status;
    state.productListConfig.statusReason = (payload.statusReason!==undefined)?payload.statusReason:state.productListConfig.statusReason;
    state.productListConfig.upgradeStatus = (payload.upgradeStatus!==undefined)?payload.upgradeStatus:state.productListConfig.upgradeStatus;
    state.productListConfig.version = (payload.version!==undefined)?payload.version:state.productListConfig.version;
    state.productListConfig.supplier = (payload.supplier!==undefined)?payload.supplier:state.productListConfig.supplier;
    state.productListConfig.tariff = (payload.tariff!==undefined)?payload.tariff:state.productListConfig.tariff;
    state.productListConfig.outOfContract = (payload.outOfContract!==undefined)?payload.outOfContract:state.productListConfig.outOfContract;
    state.productListConfig.outOfPromo = (payload.outOfPromo!==undefined)?payload.outOfPromo:state.productListConfig.outOfPromo;
    state.productListConfig.hardware = (payload.hardware!==undefined)?payload.hardware:state.productListConfig.hardware;
    state.productListConfig.ownPhoneSetup = (payload.ownPhoneSetup!==undefined)?payload.ownPhoneSetup:state.productListConfig.ownPhoneSetup;
    state.productListConfig.ipex = (payload.ipex!==undefined)?payload.ipex:state.productListConfig.ipex;
    state.productListConfig.callRecording = (payload.callRecording!==undefined)?payload.callRecording:state.productListConfig.callRecording;
    state.productListConfig.international = (payload.international!==undefined)?payload.international:state.productListConfig.international;
    state.productListConfig.audio = (payload.audio!==undefined)?payload.audio:state.productListConfig.audio;
    state.productListConfig.nonGeo = (payload.nonGeo!==undefined)?payload.nonGeo:state.productListConfig.nonGeo;
    state.productListConfig.crmConnect = (payload.crmConnect!==undefined)?payload.crmConnect:state.productListConfig.crmConnect;
    state.productListConfig.phoneDelivery = (payload.phoneDelivery!==undefined)?payload.phoneDelivery:state.productListConfig.phoneDelivery;
    state.productListConfig.numberPort = (payload.numberPort!==undefined)?payload.numberPort:state.productListConfig.numberPort;
  },

  SET_PRODUCTS_LIST(state, payload) {
    state.productList = payload.data;
    state.productListConfig.paginationCount = parseInt(payload.headers['pagination-count']);
    state.productListConfig.paginationLimit = parseInt(payload.headers['pagination-limit']);
    state.productListConfig.paginationPage = parseInt(payload.headers['pagination-page']);
    state.productListLoading = false;
    state.productListError = null;
  },

  SET_PRODUCTS_LIST_LOADING(state) {
    state.productListLoading = true;
    state.productListError = null;
  },

  SET_PRODUCTS_LIST_ERROR(state, payload) {
    state.productListLoading = false;
    state.productListError = payload;
  },
};

const actions = {
  async updateProductListPagination({ commit, dispatch }, payload) {
    const multiSort = payload.sortBy.reduce((acc, val, index) => {
      let sort = payload.sortDesc[index] ? `${val}.desc` : `${val}.asc`;
      acc.push(sort);
      return acc;
    }, []);
    commit("UPDATE_PRODUCTS_LIST_FILTERS", { ...payload, multiSort });
    await dispatch("fetchProductList");
  },

  async fetchProductList({ state, commit }) {
    try {
      commit("SET_PRODUCTS_LIST_LOADING");
      let data = await productsAPI.loadAllProducts(state.productListConfig);
      commit("SET_PRODUCTS_LIST", data);
    } catch(err) {
      commit("SET_PRODUCTS_LIST_ERROR", err);
    }
  },
};

const getters = {
  getProductListConfigs: (state) => state.productListConfig,
  getProductList: state => state.productList,
  getProductListLoading: state => state.productListLoading
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
